// Follow every internal link. Unpoly honours its own `noFollowSelectors`
// (`[up-follow=false]`, `[target]`, `[download]`, mailto:, cross-origin, …) for
// following, preloading and instant clicks — so a link opts out via
// `up-follow="false"`, not via a `:not()` clause here.
up.link.config.followSelectors.push('a[href]')
up.link.config.preloadSelectors.push('a[href]')
up.link.config.instantSelectors.push('a[href]')

// Unpoly scrolls to anchors itself (`up.viewport.revealHash` on `hashchange`),
// so the browser's `scroll-margin-top` never applies. Declare the sticky
// backend topbar as a top obstruction, otherwise every revealed element — an
// anchor target, a validation error — lands underneath it.
up.viewport.config.fixedTopSelectors.push('.topbar')

// An auth screen owns the whole document, so it must never be swapped into the
// shell of the page it replaces (doc/frontend.md, „Antworten, die Unpoly nicht
// einsetzen darf").
up.on('up:fragment:loaded', (event) => {
  if (!event.response.header('X-Auth-Screen')) return

  event.preventDefault()
  up.network.loadPage({ url: event.response.url })
})
